import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { TextInputControl } from "@cloudpivot/form/src/common/controls/input-controls/text-input-control";
import { H3Input, H3Textarea } from "h3-mobile-vue";
import MutilText from "@cloudpivot/form/src/common/components/mutil-text.vue";
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
let MobileInputText = class MobileInputText extends TextInputControl {
    constructor() {
        super(...arguments);
        this.timer = null;
    }
    onBlur() {
        super.validate();
    }
    scan() {
        RelevanceFormControl.service.scan(this.setVal);
    }
    setVal(val) {
        this.ctrl.value = val.length === 0 ? null : val;
        this.val = this.ctrl.value;
        if (!val) {
            return;
        }
        setTimeout(() => {
            let h3Input = this.$refs.h3Input;
            if (h3Input && h3Input.onInputChange) {
                // h3Input.onInputChange(val);
                const textinput = h3Input.$refs.textinput;
                if (textinput && textinput.reSetHeight) {
                    textinput.reSetHeight(textinput.$refs.textarea);
                }
            }
        }, 50);
    }
    onChange() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.ctrl.value = this.val.length === 0 ? null : this.val;
        }, 500);
    }
    onChangeTextarea() {
        let el = this.$refs.h3Textarea.$el;
        let h = el.offsetHeight;
        el.style.height = `${el.offsetHeight}px`;
        this.ctrl.value = this.val.length === 0 ? null : this.val;
        setTimeout(() => {
            el.style.height = "auto";
        }, 16.66666666);
    }
};
MobileInputText = tslib_1.__decorate([
    Component({
        name: "mpbile-input-text",
        components: {
            H3Input,
            H3Textarea,
            MutilText
        }
    })
], MobileInputText);
export default MobileInputText;
